import { render, staticRenderFns } from "./SGPFormBotaoComponent.vue?vue&type=template&id=3396610a"
import script from "./SGPFormBotaoComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormBotaoComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormBotaoComponent.vue?vue&type=style&index=0&id=3396610a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports